module.exports = __webpack_public_path__ + "img/농협카드.3f4d22c6.png";